import { TRootState } from "Redux/Reducers";

export const getEmployee = (id: string) => (state: TRootState) => state.employee.entries[id];
